//Dependencies
import React from 'react';
import { Popover } from 'antd';
import { Link } from 'react-router-dom';
import { EnvironmentOutlined, HomeFilled } from '@ant-design/icons';
//Components
import Popover01 from '../popovers/Popover01';

/* MENU BAR */
const Menu01 = (props) =>
{
  const { bottom, height, visible } = props;
  if(!visible) return null;
  
  return(
    <footer 
      className = {` fixed bottom-0 flex justify-center items-center bg-white text-gray-800 w-screen border-t-2 border-slate-500 drop-shadow-xl z-[1000] `}
      style = {{height : height, bottom : bottom}}
    >
      <div className = ' w-[350px] flex justify-center items-center h-full '>
        <Link 
          className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
          to          = {'/'}
        >
          <HomeFilled className = " text-3xl lg:text-4xl flex "/>
        </Link>

        <div className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600">
          <Popover
            content = 
            {
              () => <Popover01/>
            }
            trigger = "click"
          >
            <div
              className = "flex flex-1 justify-center items-center text-gray-900 hover:text-sky-600 cursor-pointer"
            >
              <EnvironmentOutlined className = " text-3xl lg:text-4xl flex "/>
            </div>
          </Popover>
        </div>
      </div>
    </footer>
  );
}

export default Menu01;